export class Response {
  constructor(
    public response_code: number,
    public message: string,
    public data: any) {
  }
}
